module.exports = __webpack_public_path__ + "static/img/fa-calendar-alt.5a586008.svg";